exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-menu[data-v-318d8442] {\n  display: block;\n}\n", ""]);

// exports
